export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";